export default __webpack_public_path__ + "static/Acta-Book-3c00fba851fe9222e90e6652f1f0fc5b.woff";